import { getAuthToken, isAuthenticated } from "./AuthHelpers";

const init = () => {
  const w = window;
  const token = getAuthToken();

  w.axios = require("axios");

  if (isAuthenticated()) {
    w.axios.defaults.headers.common.Authorization = token;
    return "success";
  }

  delete w.axios.defaults.headers.common.Authorization;
  return "failed";
};

export default init;
